import { render } from "./CategoryShowView.vue?vue&type=template&id=27e25f5a&scoped=true"
import script from "./CategoryShowView.vue?vue&type=script&lang=js"
export * from "./CategoryShowView.vue?vue&type=script&lang=js"

import "./CategoryShowView.vue?vue&type=style&index=0&id=27e25f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e25f5a"]])

export default __exports__